export const timeFormat = (date: string): string => {
  const timeInDate = new Date(date)

  const hours = timeInDate.getHours()
  const minutes = timeInDate.getMinutes()

  return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}`
}
